import React, { Suspense } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { UserData } from "../AppRoutes";

interface OCAllInRoutesProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<UserData | null>>;
}

const OCAllInRoutes: React.FC<OCAllInRoutesProps> = ({
  setIsAuthenticated,
}) => {
  const MainPage = React.lazy(() => import("../../pages/main-pages/MainPage"));
  const TermData = React.lazy(
    () => import("../../pages/main-pages/oc-all-in/term-data/TermData"),
  );
  const Events = React.lazy(
    () => import("../../pages/main-pages/oc-all-in/events/list/EventsList"),
  );

  const Rewards = React.lazy(
    () => import("../../pages/main-pages/oc-all-in/rewards/Rewards"),
  );
  const Reports = React.lazy(
    () => import("../../pages/main-pages/oc-all-in/reports/Reports"),
  );
  const FAQManagement = React.lazy(
    () =>
      import("../../pages/main-pages/oc-all-in/FAQ-management/list/FAQManagementList"),
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/* MainPage layout */}

      <Routes>
        <Route
          path="/"
          element={<MainPage setIsAuthenticated={setIsAuthenticated} />}
        >
          <Route index element={<Navigate to="term-data" replace />} />
          <Route path="term-data" element={<TermData />} />
          <Route path="events" element={<Events />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="reports" element={<Reports />} />
          <Route path="faq-management" element={<FAQManagement />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default OCAllInRoutes;
